"use strict";
import { createAdaptiveRefetchContext } from "graphql/data/apollo/AdaptiveRefetch";
import { useAccount } from "hooks/useAccount";
import usePrevious from "hooks/usePrevious";
import ms from "ms";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from "react";
import { useFiatOnRampTransactions } from "state/fiatOnRampTransactions/hooks";
import { useInterval } from "utilities/src/time/timing";
const { Provider: AdaptiveAssetActivityProvider, useQuery: useAssetActivityQuery } = createAdaptiveRefetchContext();
const SubscriptionContext = createContext(void 0);
export function AssetActivityProvider({ children }) {
  const account = useAccount();
  const previousAccount = usePrevious(account.address);
  const result = useMemo(() => ({
    loading: false,
    data: void 0,
    error: void 0
  }), []);
  const fiatOnRampTransactions = useFiatOnRampTransactions();
  const query = useMemo(() => ({
    loading: false,
    data: void 0,
    error: void 0,
    refetch: () => Promise.resolve({})
  }), []);
  const fetch = useCallback(
    () => Promise.resolve(),
    //   lazyFetch({
    //     variables: {
    //       account: account.address ?? '',
    //       chains: GQL_MAINNET_CHAINS_MUTABLE,
    //       // Include the externalsessionIDs of all fiat on-ramp transactions in the local store,
    //       // so that the backend can find the transactions without signature authentication.
    //       onRampTransactionIDs: Object.values(fiatOnRampTransactions).map(
    //         (transaction) => transaction.externalSessionId,
    //       ),
    //     },
    //   }),
    []
  );
  useInterval(async () => {
    if (Object.values(fiatOnRampTransactions).some(
      (transaction) => !transaction.syncedWithBackend && transaction.forceFetched
    )) {
      fetch();
    }
  }, ms("15s"));
  return <SubscriptionContext.Provider value={result}><AdaptiveAssetActivityProvider query={query} fetch={fetch} stale={account.address !== previousAccount}>{children}</AdaptiveAssetActivityProvider></SubscriptionContext.Provider>;
}
export function useAssetActivitySubscription() {
  const value = useContext(SubscriptionContext);
  if (!value) {
    return { data: void 0 };
  }
  return value;
}
function useSubscribedActivities() {
  const account = useAccount();
  const previousAccount = usePrevious(account.address);
  const [subscribedActivities, setSubscribedActivities] = useState([]);
  useEffect(() => {
    if (account.address !== previousAccount) {
      setSubscribedActivities([]);
    }
  }, [account.address, previousAccount]);
  const subscription = useAssetActivitySubscription();
  useEffect(() => {
    const subscribedActivity = subscription.data?.onAssetActivity;
    if (subscribedActivity) {
      setSubscribedActivities((prev) => [subscribedActivity, ...prev]);
    }
  }, [subscription.data?.onAssetActivity]);
  return subscribedActivities;
}
export function useAssetActivity() {
  const query = useAssetActivityQuery();
  const { loading, data } = query;
  const fetchedActivities = data?.portfolios?.[0]?.assetActivities;
  const subscribedActivities = useSubscribedActivities();
  const activities = useMemo(() => {
    if (!fetchedActivities) {
      return subscribedActivities;
    }
    return [...subscribedActivities, ...fetchedActivities];
  }, [subscribedActivities, fetchedActivities]);
  return { activities, loading };
}
